import ResizeObserver from 'resize-observer-polyfill';
import moduleInit from '@utilities/module-init';
import video from '@utilities/video';
import image from '@utilities/image';

var urlCheck;

UrlExists();

const pathname = window.location.pathname

function fillCanvas(){

	let gyro = false;
	window.addEventListener("devicemotion", function(event){
		if(event.rotationRate.alpha || event.rotationRate.beta || event.rotationRate.gamma)
			gyro = true;
	});

	const canvasContainer = document.getElementById('canvas-container');

    let margin = 75;
    let watch = 100;
	// let levels = 9;
	// let perc_min = [5, 10, 17, 25, 34, 45, 57, 70, 84];
    // let perc_max = [16, 30, 43, 55, 66, 75, 83, 90, 96];

    let spacing = 15;
    let firstrun = true;

    let levels = 4;

    let perc_min = [10, 25, 45, 70];
    let perc_max = [30, 55, 75, 90];

	let accx, accy;
	let objectSizes;
	let globalX, globalY, default_perc;
	let easing = 0.15;
	let source_d, source_e, source_m, source_o;

	let letter_d, letter_e, letter_m, letter_o;

	let sketch = function(p) {
		p.preload = function() {

            if (urlCheck) {
				source_d = p.loadImage("/assets/images/d.png");
				source_e = p.loadImage("/assets/images/e.png");
				source_m = p.loadImage("/assets/images/m.png");
				source_o = p.loadImage("/assets/images/o.png");
				
				if (document.documentElement.classList.contains('general')) {
					source_d = p.loadImage("/assets/images/d.png");
					source_e = p.loadImage("/assets/images/e.png");
					source_m = p.loadImage("/assets/images/m.png");
					source_o = p.loadImage("/assets/images/o.png");
				}
				if (document.documentElement.classList.contains('demo-2019')) {
					source_d = p.loadImage("/assets/images/2_r.png");
					source_e = p.loadImage("/assets/images/0_r.png");
					source_m = p.loadImage("/assets/images/1_r.png");
					source_o = p.loadImage("/assets/images/9_r.png");
				}
				if (document.documentElement.classList.contains('theme-darkyellow')) {
					source_d = p.loadImage("/assets/images/2_y.png");
					source_e = p.loadImage("/assets/images/0_y.png");
					source_m = p.loadImage("/assets/images/2_y.png");
					source_o = p.loadImage("/assets/images/2_y.png");
				}
			} else {
				source_d = p.loadImage("/assets/images/4_y.png");
				source_e = p.loadImage("/assets/images/0_y.png");
				source_m = p.loadImage("/assets/images/4_y.png");
				urlCheck = false;
			}
        
		}

		p.setup = function() {
            objectSizes = getObjectSizes(canvasContainer);
            canvasObserver.observe(canvasContainer);
			p.createCanvas(objectSizes.width, objectSizes.height);
			p.rectMode(p.CORNER);
			p.noStroke();
			default_perc = 100/(levels+1);
			globalX = objectSizes.width/2;
			globalY = objectSizes.height/2;
            p.frameRate(60);

            if(objectSizes.width < 440){
                spacing = 5;
            }

			if (urlCheck) {
				letter_d = new Mesh(0, 0, (objectSizes.width/2)-spacing, (objectSizes.height/2)-spacing, source_d);
				letter_e = new Mesh(objectSizes.width/2, 0, objectSizes.width/2, (objectSizes.height/2)-spacing, source_e);
				letter_m = new Mesh(0, objectSizes.height/2, (objectSizes.width/2)-spacing, objectSizes.height/2, source_m);
				letter_o = new Mesh(objectSizes.width/2, objectSizes.height/2, (objectSizes.width/2)-spacing, objectSizes.height/2, source_o);
			} else {

				letter_d = new Mesh(0, 0, (objectSizes.width/3)-spacing, objectSizes.height, source_d);
				letter_e = new Mesh(objectSizes.width/3, 0, (objectSizes.width/3)-spacing, objectSizes.height, source_e);
				letter_m = new Mesh((objectSizes.width/3)*2, 0, (objectSizes.width/3)-spacing, objectSizes.height, source_m);
			}
		}

		p.draw = function() {
			p.clear();

			if(gyro){
				if(accx != undefined){
					globalX = globalX+accx*2;
                }

				if(accy != undefined){
					globalY = globalY-accy*2;
				}
			} else {
				let targetX = p.mouseX;
				let dx = targetX - globalX;
				globalX += dx * easing;

				let targetY = p.mouseY;
				let dy = targetY - globalY;
				globalY += dy * easing;
			}

			if(globalY < margin) globalY = margin;
			if(globalX < margin) globalX = margin;
			if(globalY > objectSizes.height-margin) globalY = objectSizes.height-margin;
            if(globalX > objectSizes.width-margin) globalX = objectSizes.width-margin;

            letter_d.display(globalX, globalY);
            letter_e.display(globalX, globalY);
            letter_m.display(globalX, globalY);
			if (urlCheck) {
				letter_o.display(globalX, globalY);
			}

            if(firstrun){
                firstrun = false;
                moduleInit('[js-hook-image]', image);
                moduleInit('[js-hook-video]', video);
            }
		}

		class Mesh {

			constructor(_x, _y, _w, _h, _source) {
				this.x = _x;
				this.y = _y;
				this.w = _w;
				this.h = _h;
				this.source = _source;

				this.tiles = [];

				this.lines_left = [];
				this.lines_right = [];
				this.lines_up = [];
				this.lines_down = [];
				this.lines_x = [];
				this.lines_y = [];

				this.ssx = this.source.width/(levels*2+2);
				this.ssy = this.source.height/(levels*2+2);

				for(let i = 0; i < levels; i++){
					this.lines_left[i] = 0;
					this.lines_right[i] = 0;
					this.lines_up[i] = 0;
					this.lines_down[i] = 0;
				}

				for(let i = 0; i < levels*2+2; i++){
					this.lines_x[i] = 0;
					this.lines_y[i] = 0;
                }

                for(let i = 0; i < levels*2+2; i++){
					this.tiles[i] = [];
					for(let j = 0; j < levels*2+2; j++){
						let tilex = Math.ceil(j*this.ssx);
						let tiley = Math.ceil(i*this.ssy);
						this.tiles[i][j] = this.source.get(tilex, tiley, this.ssx, this.ssy);
					}
                }
            }

            updatePositions(_x, _y, _w, _h){
                this.x = _x;
				this.y = _y;
				this.w = _w;
				this.h = _h;
            }

			display(tx, ty){

				if (tx < this.x-watch) {
					this.xvalue = -1;
					this.curX = margin;
				} else if (tx > this.x+this.w+watch) {
					this.xvalue = 1;
					this.curX = this.w-margin;
				} else {
					this.xvalue = p.map(tx, this.x-watch, this.x+this.w+watch, -1, 1);
					this.curX = p.map(tx, this.x-watch, this.x+this.w+watch, margin, this.w-margin);
                }

				if (this.xvalue <= 0) {
					for (let i = 0; i < this.lines_left.length; i++) {
						let perc = p.map(this.xvalue, -1, 0, perc_min[i], default_perc*(i+1));
						this.lines_left[i] = (this.curX/100)*perc;
						this.lines_right[i] = this.curX+((this.w-this.curX)/100)*perc;
					}
				} else {
					for (let i = 0; i < this.lines_left.length; i++) {
						let perc = p.map(this.xvalue, 0, 1, default_perc*(i+1), perc_max[i]);
						this.lines_left[i] = (this.curX/100)*perc;
						this.lines_right[i] = this.curX+((this.w-this.curX)/100)*perc;
					}
				}

				if (ty < this.y-watch) {
					this.yvalue = -1;
					this.curY = margin;
				} else if (ty > this.y+this.h+watch) {
					this.yvalue = 1;
					this.curY = this.h-margin;
				} else {
					this.yvalue = p.map(ty, this.y-watch, this.y+this.h+watch, -1, 1);
					this.curY = p.map(ty, this.y-watch, this.y+this.h+watch, margin, this.h-margin);
                }

				if (this.yvalue <= 0) {
					for (let i = 0; i < levels; i++) {
						let perc = p.map(this.yvalue, -1, 0, perc_min[i], default_perc*(i+1));
						this.lines_up[i] = (this.curY/100)*perc;
						this.lines_down[i] = this.curY+((this.h-this.curY)/100)*perc;
					}
				} else {
					for (let i = 0; i < levels; i++) {
						let perc = p.map(this.yvalue, 0, 1, default_perc*(i+1), perc_max[i]);
						this.lines_up[i] = (this.curY/100)*perc;
						this.lines_down[i] = this.curY+((this.h-this.curY)/100)*perc;
					}
                }

				this.lines_x[0] = 0;
                this.lines_y[0] = 0;

                for (let i = 0; i < levels; i++) {
                    this.lines_x[i+1] = this.lines_left[i];
                    this.lines_y[i+1] = this.lines_up[i];
                }

                this.lines_x[levels+1] = this.curX;
                this.lines_y[levels+1] = this.curY;

                for (let i = levels+2; i < this.lines_x.length; i++) {
                    this.lines_x[i] = this.lines_right[i-levels-2];
                    this.lines_y[i] = this.lines_down[i-levels-2];
                }

				for (let i = 0; i <= this.lines_y.length-1; i++) {
					for (let j = 0; j <= this.lines_x.length-1; j++) {
						if (j == this.lines_x.length-1 || i == this.lines_y.length-1) {
							if (j == this.lines_x.length-1 && i != this.lines_y.length-1) {
								p.image(this.tiles[i][j], this.lines_x[j]+this.x, this.lines_y[i]+this.y, (this.w+this.x)-(this.lines_x[j]+this.x)+1, (this.lines_y[i+1]+this.y)-(this.lines_y[i]+this.y)+1);
							} else if (j != this.lines_x.length-1 && i == this.lines_y.length-1) {
								p.image(this.tiles[i][j], this.lines_x[j]+this.x, this.lines_y[i]+this.y, (this.lines_x[j+1]+this.x)-(this.lines_x[j]+this.x)+1, (this.h+this.y)-(this.lines_y[i]+this.y)+1);
							} else {
                                p.image(this.tiles[i][j], this.lines_x[j]+this.x, this.lines_y[i]+this.y, (this.w+this.x)-(this.lines_x[j]+this.x)+1, (this.h+this.y)-(this.lines_y[i]+this.y)+1);
							}
						} else {
							p.image(this.tiles[i][j], this.lines_x[j]+this.x, this.lines_y[i]+this.y, (this.lines_x[j+1]+this.x)-(this.lines_x[j]+this.x)+1, (this.lines_y[i+1]+this.y)-(this.lines_y[i]+this.y)+1);
						}
					}
				}
			}
		}

		const canvasObserver = new ResizeObserver(entries => {
			objectSizes.width = entries[0].contentRect.width;
			objectSizes.height = entries[0].contentRect.height;
            p.resizeCanvas(objectSizes.width, objectSizes.height);

            margin = objectSizes.width/20;
            watch = objectSizes.width/15;
            if(objectSizes.width < 440){
                spacing = 5;
            } else {
                spacing = 10;
            }

            if(letter_d && letter_e && letter_m){
				if (urlCheck){
					letter_d.updatePositions(0, 0, (objectSizes.width/2)-spacing, (objectSizes.height/2)-spacing);
					letter_e.updatePositions(objectSizes.width/2, 0, objectSizes.width/2, (objectSizes.height/2)-spacing);
					letter_m.updatePositions(0, objectSizes.height/2, (objectSizes.width/2)-spacing, objectSizes.height/2);
					letter_o.updatePositions(objectSizes.width/2, objectSizes.height/2, (objectSizes.width/2)-spacing, objectSizes.height/2);
				} else {
					letter_d.updatePositions(0, 0, (objectSizes.width/3)-spacing, objectSizes.height);
					letter_e.updatePositions(objectSizes.width/3, 0, (objectSizes.width/3)-spacing, objectSizes.height);
					letter_m.updatePositions((objectSizes.width/3)*2, 0, (objectSizes.width/3), objectSizes.height);
				}
            }
		});

		window.addEventListener('devicemotion', function(e) {
			// get accelerometer values
			accx = parseInt(e.accelerationIncludingGravity.x);
			accy = parseInt(e.accelerationIncludingGravity.y);
			accy += 4;
		});
	}

    new p5(sketch, canvasContainer);
}

function getObjectSizes(element){
	const { width, height } = element.getBoundingClientRect();
	return { width, height };
}

function UrlExists(url) {
    var http = new XMLHttpRequest();
    http.open('HEAD', window.location.href, false);
    http.send();
    if (http.status != 404)
		urlCheck = true;
    else
		urlCheck = false;
}

export default fillCanvas;



// WEBPACK FOOTER //
// /Users/sandersturing/Sites/SD/demo.test/frontend/source/utilities/canvas.js